import type { TextStyle } from '@worldathletics/types';

/** WA PDF brand green — semantic note color in the corpus. */
export const NOTE_INLINE_COLOR = '#009640';

/** Brand highlight-yellow-500 — warning / exception text. */
export const EXCEPTION_INLINE_COLOR = '#ffd321';

export const TEXT_STYLE_INLINE_COLORS = {
  note: NOTE_INLINE_COLOR,
  exception: EXCEPTION_INLINE_COLOR,
} as const satisfies Partial<Record<TextStyle, string>>;

const EDITOR_TOOL_FOR_STYLE: Record<TextStyle, string> = {
  body: 'paragraph',
  note: 'note',
  example: 'example',
  exception: 'exception',
};

const STYLE_FOR_EDITOR_TOOL: Record<string, TextStyle> = {
  paragraph: 'body',
  note: 'note',
  example: 'example',
  exception: 'exception',
};

/** Zero-width space keeps the caret inside the colored span when text is empty. */
const EMPTY_COLORED_TEXT_MARKER = '\u200b';

function coloredSpanWrap(color: string): string {
  return `<span style="color:${color}">${EMPTY_COLORED_TEXT_MARKER}</span>`;
}

export function defaultTextForStyle(style: TextStyle): string {
  if (style === 'note' || style === 'exception') {
    return coloredSpanWrap(TEXT_STYLE_INLINE_COLORS[style]);
  }
  return '';
}

export function editorToolForStyle(style: TextStyle): string {
  return EDITOR_TOOL_FOR_STYLE[style];
}

export function styleForEditorTool(toolName: string): TextStyle {
  return STYLE_FOR_EDITOR_TOOL[toolName] ?? 'body';
}

export function isInformationalTextStyle(style: TextStyle): boolean {
  return style === 'note' || style === 'exception';
}
